import { handleActions } from 'redux-actions'
import * as rawActions from '../actions'

export default handleActions(
  {
    [rawActions.openCustomVideoOptionsDialog](state, action) {
      return true
    },
    [rawActions.closeCustomVideoOptionsDialog](state, action) {
      return false
    },
    [rawActions.resetGalleryState](state, action) {
      return false
    },
  },
  false
)
